<template>
  <div class="page_container warehousingPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/warehousIndex/wManageIndex' }"
          >库存管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>明细数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="main_shop_wrap">
        <div class="block flex-rowl">
          <p>
            商品名称：<span>{{ shopItem.commodityname }}</span>
          </p>
          <p>
            所属企业：<span>{{ shopItem.qyname }}</span>
          </p>
          <p>
            SKU采购编码：<span>{{ shopItem.sku }}</span>
          </p>
          <p>
            品牌标签：<span>{{ shopItem.brandname }}</span>
          </p>
          <p>
            ISBN编码：<span>{{ shopItem.ISBN }}</span>
          </p>
          <p>
            所属分类：<span>{{ shopItem.labelname }}</span
            ><span v-if="shopItem.labelname2">、{{ shopItem.labelname2 }}</span
            ><span v-if="shopItem.labelname3">、{{ shopItem.labelname3 }}</span>
          </p>
        </div>
        <div class="block">
          <p>
            当前库存总量：<span>{{ shopItem.kunum }}</span>
          </p>
        </div>
        <div class="select_add flex-rowl">
          <p class="btn flex-rowl" @click="handleGo('add')">
            <i class="iconfont icon-xinzeng"></i> 添加库存
          </p>
          <p class="btn flex-rowl" @click="handleGo('reduce')">
            <i class="iconfont icon-xinzeng"></i> 出库操作
          </p>
        </div>
        <div class="block">
          <h1>库存明细：</h1>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="detailList.length > 0">
          <div class="item_wrap" v-for="item in detailList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <p>
                    数量：<span>{{ item.num }}件</span>
                  </p>
                  <p>
                    位置：<span>{{ item.whid1str }}</span>
                    <span v-if="item.whid2str">/{{ item.whid2str }}</span>
                    <span v-if="item.whid3str">/{{ item.whid3str }}</span>
                    <span v-if="item.whid4str">/{{ item.whid4str }}</span>
                  </p>
                  <p>
                    属性：<span>{{ item.attr ? item.attr : "无" }}</span>
                  </p>
                  <!-- <p>
                    商品属性标签：<span>{{
                      item.ams_shop_commodity_attridstr ? item.ams_shop_commodity_attridstr : '无'
                    }}</span>
                  </p>
                  <p>
                    商品属性标签值：<span>{{
                      item.ams_shop_commodity_attr_valuestr ? item.ams_shop_commodity_attr_valuestr : '无'
                    }}</span>
                  </p> -->
                  <!-- <p>
                    商品批次：<span>{{ item.makerno }}</span>
                  </p>
                  <p>
                    生产商：<span>{{ item.makername_str }}</span>
                  </p> -->
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="尚未添加入库参数"
          v-if="!loading && detailList.length == 0"
        ></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  queryShopWareRecord,
  getCommidityDetail,
  encryptstringview,
  encryptstringadd
} from "../../api/api";
import { getShopInventoryRecordList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "wManageSettingList",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      cmid: "",
      loading: false,
      keyword: "",
      realnum: 0,
      detailList: [],
      shopItem: "", // 商品详情

      params: {
        pageindex: 1,
        pagesize: 20,
        cmid: "",
      },
      listTotal: 0,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    
    let { routerList, menuItem, USERINFO } = this.$store.state;
    let { name } = this.$route;

    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;
    this.getMenuAuthTwo();

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmid, keyword } = JSON.parse(res.jsondata);
        this.keyword = keyword;
        this.cmid = cmid;
        this.params.cmid = cmid;
        this.getCommidityDetail();
        // this.getWearRecord(keyword);
        this.getShopInventoryRecordList();
      }else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 获取商品详情
    getCommidityDetail() {
      getCommidityDetail({ id: this.cmid }).then((res) => {
        this.shopItem = res;
      });
    },

    // 入库记录
    getWearRecord(keyword) {
      this.loading = true;
      queryShopWareRecord({
        keyword,
        qyguid: this.$store.state.USERINFO.qy.qyguid,
      }).then((res) => {
        if (res.status) {
          this.loading = false;
          return;
        }
        let num = 0;
        if (res.length > 0) {
          res.forEach((v) => {
            num += v.num;
          });
          this.realnum = num;
        }
        this.detailList = res;
        this.loading = false;
      });
    },

    // 获取商品库存明细表
    getShopInventoryRecordList() {
      this.loading = true;
      getShopInventoryRecordList(this.params).then((res) => {
        this.detailList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getShopInventoryRecordList();
    },

    async handleGo(type) {
      if (type == "reduce") {
        this.$message.warning("即将开放");
        return;
      }
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      // this.$router.push(
      //   `/warehousIndex/wManageSettingItem/${this.keyword}/${this.cmid}/${type}`
      // );
      
      this.encryptstringadd('wManageSettingItem', {keyword: this.keyword, cmid: this.cmid, type})
      // this.$router.push({name:'wManageSettingItem', params:{keyword: this.keyword, cmid: this.cmid, type}})
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          // this.$router.push({
          //   name,
          //   params,
          // });
           window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  .main_shop_wrap {
    font-size: 16px;
    color: #404d6c;
    padding: 15px 0 0;
    .block {
      margin-bottom: 10px;
      font-size: 14px;
      h1 {
        font-size: 18px;
        color: #444444;
        margin-top: 10px;
      }
    }
    p {
      margin-right: 20px;
    }
    .btn {
      border: 1px solid #6b5e84;
      padding: 4px 15px;
      border-radius: 45px;
      margin-right: 20px;
      font-size: 14px;
      cursor: pointer;
      .iconfont {
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
  .intro_box {
    p {
      margin-right: 60px;
      margin-bottom: 10px;
    }
  }
  .list_wrap {
    height: 48vh;
  }
}
</style>